module.exports = {
  // apibasePath: "https://divcrm.divsolution.com", // test
  // apibasePath: "https://backend.accountiez.com", // live
  // apibasePath: "https://testbroker.accountiez.com", // test
  // apibasePath: "https://broker.accountiez.com", // live
  apibasePath: "https://backendmodi.accountiez.com", // test
};
